import { Injectable } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';

@Injectable({ providedIn: 'root' })
export class SplashScreenService {
  async hide(): Promise<void> {
    await SplashScreen.hide({ fadeOutDuration: 300 });
  }
}
